import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(housingAssociationIssueList);

    /** @ngInject */
    function housingAssociationIssueList($stateProvider) {
        $stateProvider.state('housing_association.issue_list', {
            url: '/zgloszenia',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/housing_association_issue_list/housing_association_issue_list.html'),
            controller: 'HousingAssociationIssueListController',
            controllerAs: 'HousingAssociationIssueListCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/housing_association_issue_list/housing_association_issue_list.route.ts